import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import apiServices from "../../service";

const initialState: any = {
  listItems: [],

  activeItem: {},
  loading: false,
  activeItemloading: false,
};
export const getFeesAndChargesListItems = createAsyncThunk(
  "feesAndCharges/getFeesAndChargesListItems",
  async (Id: string, { rejectWithValue }) => {
    try {
      const response: any = await apiServices.feesCharges.getList(Id);

      const { isError, data } = response.data;
      if (isError || !data) {
        return rejectWithValue("Failed to fetch  list");
      }

      return data;
    } catch (error: any) {
      return rejectWithValue(error.message || "An error occurred");
    }
  }
);

export const getFeesAndChargesDetailById = createAsyncThunk(
  "feesAndCharges/getFeesAndChargesDetailById",
  async (Id: string, { getState, rejectWithValue }) => {
    if (!Id) return rejectWithValue("Invalid Id ID");

    // Access the current state
    const state: any = getState();

    const itemList = state.feesAndCharges.listItems;

    // Find the valuation detail by ID in the listItems array
    const itemDetail = itemList.find((item: any) => item.commission_id === Id);
    if (itemDetail) {
      return itemDetail; // Return the detail if found
    } else {
      return rejectWithValue("item detail not found in state");
    }
  }
);

export const feesAndChargesSlice = createSlice({
  name: "feesAndCharges",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getFeesAndChargesListItems.pending, (state) => {
        state.loading = true;
        state.listItems = [];
      })
      .addCase(getFeesAndChargesListItems.fulfilled, (state, action) => {
        state.loading = false;
        state.listItems = action.payload;
      })
      .addCase(getFeesAndChargesListItems.rejected, (state, action) => {
        state.loading = false;
        console.error("Error fetching  list:", action.payload);
      })
      .addCase(getFeesAndChargesDetailById.pending, (state) => {
        state.activeItemloading = true;
        state.activeItem = {};
      })
      .addCase(getFeesAndChargesDetailById.fulfilled, (state, action) => {
        state.activeItemloading = false;
        state.activeItem = action.payload;
      })
      .addCase(getFeesAndChargesDetailById.rejected, (state, action) => {
        state.activeItemloading = false;
        console.error("Error fetching  details:", action.payload);
      });
  },
});
export const {} = feesAndChargesSlice.actions;
export default feesAndChargesSlice.reducer;
